import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import _ from "lodash";
import FETIASEntity from "../../business/FETIASEntity";

import { diff, patch } from 'jsondiffpatch'
const jdpModule = require("jsondiffpatch");

import VueRouter from "vue-router";
Vue.use(VueRouter);

import commons from '../commons/commons';
import { commonStore } from "./commonStore";
import LocalStorageService from "./LocalStorageService";

let summ = function (expr, list) {
  return list.reduce(function (accumulator, row) {
    return accumulator + expr(row);
  }, 0);
}

import Axios from "axios";
import webAppConfig from "../commons/webApp.config";

import router from '../routers/clientRouters';


export const classificationStore = new Vuex.Store({
  state: {
    ...commonStore.state,
    users: [],
    states: [],
    previousClone: null,
    submissionClone: null,
    interimClone: null,
    appliedChange: false,
    needSync: false,
    baseServer: "",
    form: null,
    originalForm: null,
    formData: null,
    formDesign: null,
    locusId: null,
    vectorId: null,
    vector: null,
    activityId: null,
    activityComplexity : null,
    documentId: null,
    token: LocalStorageService.getAccessToken(),
    currentUsername: null,
    query: null,
    initial: null,
    synchronizing: false,
    backendTriggers: null,
    frontTriggers: null,
    syncError: false,
    syncErrorRetry: 0,
    syncLastTime: null,
    activityName: null,
    workspace: null,
    polling: null,
    formAbortController: null,
    syncAbortController: null,
    cachedForms: {}
  },
  watch: {
    formData(newValue, oldValue) {
      console.log("change");
    }
  },
  mutations: {
    ...commonStore.mutations,
    reset(state) {
      state.activityId = null;
      state.activityComplexity = null;
    },
    setup(state, data) {
      if (data.baseServer) state.baseServer = data.baseServer;
      if (data.formData) state.formData = data.formData;

      if (state.formAbortController) {
        state.formAbortController.abort();
        state.formAbortController = null;
      }
      state.formAbortController = new AbortController();

      if (state.syncAbortController) {
        state.syncAbortController.abort();
        state.syncAbortController = null;
      }
      state.syncAbortController = new AbortController();

      state.locusId = data.locusId;
      state.vectorId = data.vectorId;
      state.activityId = data.activityId;
      state.users = data.users;
      state.query = data.query;
      state.initial = true;

      if (localStorage['ls.authorizationData']) {
        state.currentUsername = JSON.parse(localStorage['ls.authorizationData']).userName;
      }
    },
    setServer(state, data) {
      if (data.baseServer != null) state.baseServer = data.baseServer;
    },
    setLocusId(state, data) {
      state.locusId = data;
    },
    setVector(state, data) {
      if (data.vectorId != null) {
        state.vectorId = data.vectorId;
        state.vector = {
          id: data.vectorId,
          name: data.vectorName,
          emoji: data.vectorEmoji
        }
      }
    },
    setVectorId(state, data) {
      state.vectorId = data;
    },
    setWorkspace(state, data) {
      state.workspace = data;
      state.client.defaults.headers['workspace'] = state.workspace;
    },
    basicSetup(state, data) {
      state.baseServer = data.baseServer;
      // state.token = data.token;
      state.documentId = data.documentId;
      state.vectorId = data.vectorId;
    },
    loadForm(state, form) {
      state.syncLastTime = new Date()
      state.previousClone = null;
      state.form = form;
      state.originalForm = null;
      state.documentId = null;
    },
    loadFormData(state, formData) {
      state.formData = formData;
    },
    updateDocumentId(state, payload) {
      if (payload) {
        state.documentId = payload.documentId;
        state.vectorId = payload.vectorId;
      } else {
        state.documentId = null;
      }

    },
    syncFormData(state, formData) {
      state.syncLastTime = new Date()
      state.appliedChange = true;
      state.formData = formData;
    },
    updateForm(state, form) {
      if (!state.originalForm) {
        state.originalForm = state.form;
      }

      state.form = form;
    },
    revertForm(state) {
      state.form = state.originalForm;
    },
    syncTriggers(state, data) {
      state.frontTriggers = data.frontTriggers;
      state.backendTriggers = data.backendTriggers;
    },
    storeFormDesign(state, formDesign) {
      state.formDesign = formDesign;
      state.vectorId = formDesign.vectorId;
      state.needSync = formDesign.needSync;
    },
    setNeedSync(state, needSync) {
      state.needSync = needSync;
    },
    resetApplyChange(state) {
      state.appliedChange = false;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setStates(state, states) {
      state.states = states
    },
    setPolling(state, polling) {
      state.polling = polling;
    }
  },
  getters: {
    formData: state => state.formData,
    uploadFormData: (state) => (payload) => {
      return {
        vectorId: state.vectorId,
        fieldName: payload.fieldName,
        fieldId: payload.fieldId,
        type: payload.formType,
        workDesignId: state.formDesign ? state.formDesign.workDesignId : null
      };
    },
    syncError: state => state.syncError,
    currentUserProfileUrl: (state) => {
      var user = state.users.find(x => x.userName == state.currentUsername);
      if (
        user &&
        user.profilePictureUrl &&
        user.profilePictureUrl.indexOf("ProfilePics") > -1
      ) {
        return state.baseServer + user.profilePictureUrl;
      }

      return '';
    },
    getCachedForm: (state) => ({ moduleId, activityId }) => {
      const key = `${moduleId}-${activityId}`;
      return state.cachedForms[key] || null;
    }
  },
  actions: {
    ...commonStore.actions,
    reset({ commit }) {
      commit('reset');
    },
    polling({ commit }, payload) {
      commit('setPolling', payload.polling);
    },
    setUsers({ commit }, payload) {
      let users = payload.users.map((x) => (
        Object.assign(x, {
          username: x.username || x.userName
        })
      ));
      commit("setUsers", users);
    },
    setStates({ commit }, payload) {
      commit("setStates", payload);
    },
    resetApplyChange({ commit }) {
      commit("resetApplyChange");
    },
    setBaseServer({ commit }, payload) {
      commit('setServer', payload);
    },
    setLocusId({ commit }, payload) {
      commit('setLocusId', payload);
    },
    setVector({ commit }, payload) {
      commit('setVector', payload);
    },
    setWorkspace({ commit }, payload) {
      commit('setWorkspace', payload)
    },
    basicSetup({ commit }, payload) {
      commit('basicSetup', payload);
    },
    setFormData({ commit }, payload) {
      commit("loadFormData", payload);
    },
    resetActivityForm({ commit }) {
      commit("loadForm", { rows: [{ items: [] }] });
      commit("loadFormData", {});
    },
    async loadDocumentForm({ state }, payload) { /* never read */
      return await state.client.post(`/api/activity/form`, payload);
    },
    async loadDocumentLegacy({ state }, payload) { /* deprecated, never read */
      return await state.client.get(payload.url);
    },
    async loadViewForm({ state }, payload) {
      try {
        let res = await state.client.post(`/api/activity/form`, {
          moduleId: payload.moduleId,
          listingId: payload.listingId,
          activityId: payload.activityId,
          entryId: payload.entryId,
          locusId: payload.locusId /* to-do delete */,
          query: payload.query
        });

        let form = res.data.classificationForm.design;
        let formData = res.data.classificationForm.default;

        if (Array.isArray(res.data.formChanges)) {
          res.data.formChanges.forEach(change => {
            // get
            let element = commons.findFormField(
              form && 
              form.rows, 
              change, 
              formData
            );
            // set
            if (element) {
              if (change.visible === true || change.visible === false) {
                Vue.set(element, 'visible', change.visible);
              }
              if (change.required === true || change.required === false) {
                Vue.set(element, 'required', change.required);
              }
              if (change.readOnly === true || change.readOnly === false) {
                Vue.set(element, 'readOnly', change.readOnly);
              }
              if (change.input != null) {
                Vue.set(element, 'input', change.input);
              }
              if (change.optionList != null) {
                Vue.set(element, 'optionList', change.optionList);
              }
            }
          });
        }

        return {
          viewData: {
            form: form,
            formData: formData
          },
          header: res.data.header,
          footer: res.data.footer
        };
      } catch(err) {
        throw err;
      } 
    },
    loadActivityFormCache({ state, commit }, payload) {
      let { setup, data } = payload;
      let classificationForm = data.classificationForm;
      state.syncError = false;
      commit("setNeedSync", false);
      commit("setup", setup); 
      state.synchronizing = true;

      if (data.header && data.header.moduleId) {
        commit("setVectorId", data.header.moduleId);
      }

      if (classificationForm) {
        if (setup.username) {
          classificationForm.default['username'] = setup.username;

          const user = state.users.find(x => x.username == setup.username);
          if (user) {
            classificationForm.default['name'] = user.displayName;
          }
        }

        commit("loadForm", classificationForm.design);
        commit("loadFormData", _.cloneDeep(classificationForm.default));
        commit("syncTriggers", classificationForm);
        state.previousClone = _.cloneDeep(classificationForm.default);
        commit("setNeedSync", classificationForm.needSync);
      }

      state.activityId = setup.activityId;
      state.activityName = setup.activity;
      state.synchronizing = false;

      if (data.hasOwnProperty("complexity")) {
        state.activityComplexity = payload.data.complexity;
      } else {
        state.activityComplexity = null;
      }
    },
    async loadActivityForm(context, payload) {
      try {
        if (!payload.hasCache) {
          context.state.syncError = false;
          context.commit("setNeedSync", false);
          context.commit("setup", payload);
          context.state.synchronizing = true;
          context.commit("loadForm", { rows: [{ items: [] }] });
          context.commit("loadFormData", {});
        }

        let res = null;
        let classificationForm = null;
        let needCache = !!payload.enableCache;

        if (payload.route) {
          let route = payload.route;
          res = await Axios.post(`${webAppConfig.baseURL}/api/activity/form`, {
            query: payload.route.query
          },
            {
              headers: {
                Authorization: `inishare ${payload.route.params.id}:${payload.route.query.code}`
              }
            })

          if(res.data.header && res.data.header.activity) {
            payload.activityId = res.data.header.activity.id
            payload.activity = res.data.header.activity.name
          } else if (res.data.header.id) {
            payload.activityId = 'edit';
            payload.activity = 'edit';
          } else {
            payload.activityId = 'create';
            payload.activity = 'create';
          }
        } else {
          let config = null;
          if (context.state.formAbortController) {
            config = {
              signal: context.state.formAbortController.signal
            }
          }

          res = await context.state.client.post(
            `/api/activity/form`,
            {
              moduleId: payload.moduleId,
              listingId: payload.listingId,
              activityId: payload.activityId,
              entryId: payload.entryId,
              locusId: context.state.locusId, /* to-do delete */
              query: payload.query
            }, 
            config
          );
        }

        classificationForm = _.cloneDeep(res.data.classificationForm);

        if (res.data.header && res.data.header.moduleId) {
          context.commit("setVectorId", res.data.header.moduleId);
        }

        if (classificationForm) {
          if (payload.username) {
            classificationForm.default['username'] = payload.username;

            var user = context.state.users.find(x => x.username == payload.username);
            if (user) {
              classificationForm.default['name'] = user.displayName;
            }
          }

          if (Array.isArray(res.data.formChanges)) {
            res.data.formChanges.forEach(change => {
              // get
              let element = commons.findFormField(
                classificationForm.design && 
                classificationForm.design.rows, 
                change, 
                classificationForm.default
              );
              // set
              if (element) {
                if (change.visible === true || change.visible === false) {
                  Vue.set(element, 'visible', change.visible);
                }
                if (change.required === true || change.required === false) {
                  Vue.set(element, 'required', change.required);
                }
                if (change.readOnly === true || change.readOnly === false) {
                  Vue.set(element, 'readOnly', change.readOnly);
                }
                if (change.input != null) {
                  Vue.set(element, 'input', change.input);
                }
                if (change.optionList != null) {
                  Vue.set(element, 'optionList', change.optionList);
                }
              }
            });
          }

          context.commit("loadForm", classificationForm.design);
          context.commit("syncTriggers", classificationForm);
          context.commit("setNeedSync", classificationForm.needSync);

          if (
            !payload.enableCache ||
            !(
              payload.activityId == "create" && 
              !classificationForm.needSync && 
              !Object.keys({...res.data.classificationForm.default}).length
            )
          ) {
            needCache = false;
            context.commit("loadFormData", classificationForm.default);
            context.state.previousClone = _.cloneDeep(classificationForm.default);
          }
        }

        context.state.activityId = payload.activityId;
        context.state.activityName = payload.activity;
        context.state.synchronizing = false;

        if (res.data.hasOwnProperty("complexity")) {
          context.state.activityComplexity = res.data.complexity;
        } else {
          context.state.activityComplexity = null;
        }

        let responseData = {
          classificationForm: res.data.classificationForm,
          header: res.data.header,
          footer: res.data.footer,
          needSync: context.state.needSync,
          needCache: needCache
        }

        if (context.state.activityComplexity != null) {
          responseData.complexity = context.state.activityComplexity;
        }

        return responseData;
      } catch(err) {
        throw err;
      }
    },
    setCachedForm({ state }, { moduleId, activityId, data }) {
      const key = `${moduleId}-${activityId}`;
      state.cachedForms[key] = data;
    },
    clearCachedForm({ state }, { moduleId, activityId }) {
      const key = `${moduleId}-${activityId}`;
      delete state.cachedForms[key];
    },
    async searchEntry(context, payload) {
      let data = {};
      let config = {};

      if (payload.data && payload.config && Object.keys(payload).length === 2) {
        data = payload.data;
        config = payload.config;
      } else {
        data = payload;
      }

      if (context.state.documentId) {
        data.documentId = context.state.documentId;
      }

      if (
        window.router && 
        window.router.currentRoute && 
        window.router.currentRoute.name == 'shareForm'
      ) {
        return await Axios.post(`${webAppConfig.baseURL}/api/activity/formselection`, data, {
          headers: {
            Authorization: `inishare ${window.router.currentRoute.params.id}:${window.router.currentRoute.query.code}`
          },
          ...config
        });
      } else {
        return await context.state.client.post("/api/activity/formselection", data, config);
      }
    },
    cartToForm(context, payload) {
      //find form field,
      let rows = this.formData[payload.fields[0].fieldName];
      payload.items.forEach(item => {
        rows.push({
          id: commons.newUUID(),
        });
      });

    },
    eventTriggered({ dispatch }, payload) {
      dispatch('synchronize', {
        activity: payload.activity,
        eventName: payload.eventName,
        eventPayload: payload.eventPayload
      });
    },
    async synchronize(context, payload) {
      console.log(`synchronize: ${payload.polling}, current: ${context.state.polling}`);

      if (payload.polling != context.state.polling && !payload.eventName) {
        console.log('secondary clear');
        clearInterval(payload.polling);
        return;
      }

      let backendTriggers = context.state.backendTriggers;
      let frontTriggers = context.state.frontTriggers;
      let sendBack = false;

      let inputFields = commons.getAllElements(null, context.state.form);

      let currentClassification = new FETIASEntity(context.state.formData, inputFields);
      let previousClassification = new FETIASEntity(context.state.previousClone, inputFields);
      let interimClassification = new FETIASEntity(context.state.interimClone, inputFields);
      let formData = currentClassification;

      if (backendTriggers != null && context.state.previousClone != null) {
        sendBack = backendTriggers.some(field => {
          return currentClassification.hasChange(previousClassification, field.primary, field.secondary)
        })
      } else if (context.state.previousClone == null) {
        sendBack = true;
      } else if (backendTriggers == null) {
        sendBack = true;
      }

      if (!sendBack && frontTriggers != null) {
        let recalculate = false;
        frontTriggers.forEach(trigger => {
          let change = context.state.interimClone == null
            || currentClassification.hasChange(interimClassification, trigger.primary, trigger.secondary);
          if (change) {
            recalculate = true;
            let field = function (displayName) {
              return formData.field(displayName)
            }

            if (trigger.secondary) {
              //table or list
              currentClassification.field(trigger.primary).forEach(row => {
                trigger.targets.forEach(targetField => {
                  try {
                    if (trigger.within) {
                      eval(`row.set('${targetField.secondary}', ${targetField.frontEndScript})`)
                    } else {
                      eval(`formData.set('${targetField.primary}', ${targetField.frontEndScript})`)
                    }
                  } catch (ex) {
                    console.log(`${trigger.primary}>${targetField.secondary}: ${targetField.primary}, ${ex}`)
                  }
                });
              })
            } else {
              //todo: check if different
              trigger.targets.forEach(targetField => {
                try {
                  if (targetField.frontEndScript == 'rowNumber()' || targetField.frontEndScript == 'rowAutoNumber') {
                    let no = 1;
                    currentClassification.field(trigger.primary).forEach(row => {
                      row.set(targetField.secondary, no);
                      no = no + 1;
                    })
                  } else {
                    eval(`formData.set('${targetField.primary}', ${targetField.frontEndScript})`)
                  }
                } catch (ex) {
                  console.log(`${trigger.primary}: ${targetField.frontEndScript}, ${ex}`)
                }

              })
            }
          }
        })

        if (recalculate) {
          context.state.formData = _.cloneDeep(context.state.formData);
          context.state.interimClone = _.cloneDeep(context.state.formData);
        }
      }

      if (!sendBack && !payload.eventName)
        return;

      let clone = _.cloneDeep(context.state.formData);
      let previousClone = _.cloneDeep(context.state.previousClone);

      if (
        (payload.eventName ||
          (sendBack &&
            JSON.stringify(clone) !== JSON.stringify(context.state.previousClone))) &&
        !context.state.synchronizing
      ) {
        console.log("[SYNC] start synchronize");
        context.state.submissionClone = clone;
        context.state.synchronizing = true;
        // fix URIError in diff
        const safeDiff = (previousObj, currentObj) => {
          try {
            return diff(previousObj, currentObj) || {};
          } catch(err) {
            const jdp = jdpModule.create({
              textDiff: { minLength: Infinity } // disables all character-level diff
            });
            return jdp.diff(previousObj, currentObj) || {}
          }
        }

        try {
          let res = null;
          let syncPayload = {
            previousFormData: previousClone,
            formDataChanges: safeDiff(previousClone, clone),
            vectorId: context.state.vectorId,
            moduleId: context.state.vectorId.toString(),
            locusId: context.state.locusId,
            query: context.state.query,
            events: payload.eventName ? [payload.eventName] : [],
            eventPayload: payload.eventPayload ? payload.eventPayload : null,
            activityName: payload.activity.name,
            activityId: payload.activity.id
          };

          if (window.router && window.router.currentRoute
            && window.router.currentRoute.name == 'shareForm') {
              res = await Axios.post(`${webAppConfig.baseURL}/api/activity/formsync`, syncPayload,
                {
                  headers: {
                    Authorization: `inishare ${window.router.currentRoute.params.id}:${window.router.currentRoute.query.code}`
                  }
                })
          } else {
            let config = null;
            if (context.state.syncAbortController) {
              config = {
                signal: context.state.syncAbortController.signal
              }
            }

            res = await context.state.client.post("/api/activity/formsync", syncPayload, config);
          }

          if (res.data == null || res.data.vectorId != context.state.vectorId) {
            context.state.syncError = false;
            context.state.syncErrorRetry = 0;
            context.state.synchronizing = false;
            return;
          }

          context.state.syncError = false;
          context.state.syncErrorRetry = 0;
          context.state.synchronizing = false;

          //no new changes from formdata
          if (
            JSON.stringify(context.state.formData) ===
            JSON.stringify(context.state.submissionClone)
          ) {
            //apply changes
            console.log("[SYNC] apply changes");

            let formData = context.state.submissionClone;
            formData = patch(formData, res.data.dataChanges);

            context.commit("syncFormData", formData);
            context.commit("syncTriggers", res.data)

            if (context.state.originalForm != null) {
              context.commit('revertForm');
            }
            if (res.data.formChanges) {
              //recursive find form element
              // form changes

              res.data.formChanges.forEach(change => {
                // get
                let element = commons.findElementById(context.state.form && context.state.form.rows, change.id, null, change.index);
                // set
                if (element) {
                  if (change.visible === true || change.visible === false) {
                    Vue.set(element, 'visible', change.visible);
                  }
                  if (change.required === true || change.required === false) {
                    Vue.set(element, 'required', change.required);
                  }
                  if (change.readOnly === true || change.readOnly === false) {
                    Vue.set(element, 'readOnly', change.readOnly);
                  }
                  if (change.input != null) {
                    Vue.set(element, 'input', change.input);
                  }
                  if (change.optionList != null) {
                    Vue.set(element, 'optionList', change.optionList);
                  }
                }
              });
            }

            if (res.data.interaction && res.data.interaction['message'] != null) {
              alert(res.data.interaction['message']);
            }

            context.state.previousClone = _.cloneDeep(formData);
          } else {
            console.log('signature unmatch')
          }
        } catch (err) {
          if (Axios.isCancel(err)) {
            context.state.syncError = false;
            context.state.syncErrorRetry = 0;
            context.state.synchronizing = false;
          } else {
            console.error(err);
            context.state.synchronizing = false;
            context.state.syncErrorRetry = context.state.syncErrorRetry + 1;
            context.state.syncError = true;
          }
        }
      }
    },
    async importData(context, payload) {
      return await context.state.client.post("/api/collection/import", payload);
    },
    async loadDocument({ state }, payload) {
      return await state.client.post('/api/activity/document', payload);
    },
    async shareForm({ state }, payload) {
      return await state.client.post('/api/activity/', payload);
    },
    async submitActivity({ state }, payload) {
      let activityApi = "/api/activity/";

      if (
        state.activityId === payload.activityId && 
        state.activityComplexity === 0 && 
        (
          payload.activityId === 'create' || 
          payload.entryIds.length === 1
        )
      ) {
        activityApi = "/api/activity/x";
      }

      if (
        window.router
        && window.router.currentRoute
        && window.router.currentRoute.name == 'shareForm'
      ) {
        return await Axios.post(`${webAppConfig.baseURL}${activityApi}`, payload,
          {
            headers: {
              Authorization: `inishare ${window.router.currentRoute.params.id}:${window.router.currentRoute.query.code}`
            }
          })
      } else {
        return await state.client.post(activityApi, payload);
      }
    },
    async saveUserPreference({ state }, payload) {
      return await state.client.post('/api/preference', payload);
    },
    updateDocumentId(context, payload) {
      context.commit("updateDocumentId", payload);
    },
    async sendComment({ state }, payload) {
      return await state.client.post('/api/activity/comment', payload)
    },
    async reactActivity({ state }, payload) {
      return await state.client.post('/api/activity/react', payload)
    },
    async retrieveHistory({ state }, { moduleId, id, history, currentPage = 0, archive }) {
      let url = `/api/activity/history/?m=${moduleId}&id=${id}&history=${history}&p=${currentPage}`;

      if (archive) {
        url += "&a=true";
      }

      return await state.client.get(url);
    },
    async retrieveNotification({ state }, payload) {
      return await state.client.get(`/api/activity/notification/?m=${payload.moduleId}&id=${payload.id}`)
    }
  }
});